import getIconForFileProvider, { getIconForGDrive } from './getIconForFileProvider';
import AttachmentDataProviderType from 'owa-service/lib/contract/AttachmentDataProviderType';
import { ControlIcons } from 'owa-control-icons';
import { FileProviderViewType, ClientOnlyFileProviderType } from 'owa-fileprovider-store';

const styles = require('./fileProvidersIcon.scss');

// The provider icons
const fileProviderIconMapping = {};
fileProviderIconMapping[AttachmentDataProviderType.OneDrivePro] = getIconForFileProvider(
    ControlIcons.OneDriveLogo,
    styles.oneDriveIcon
);
fileProviderIconMapping[AttachmentDataProviderType.OneDriveConsumer] = getIconForFileProvider(
    ControlIcons.OneDriveLogo,
    styles.oneDriveIcon
);
fileProviderIconMapping[AttachmentDataProviderType.Dropbox] = getIconForFileProvider(
    ControlIcons.DropboxLogo,
    styles.dropboxIcon
);
fileProviderIconMapping[AttachmentDataProviderType.Box] = getIconForFileProvider(
    ControlIcons.BoxLogo,
    styles.boxIcon
);
fileProviderIconMapping[AttachmentDataProviderType.Facebook] = getIconForFileProvider(
    ControlIcons.FacebookLogo,
    styles.facebookIcon
);
fileProviderIconMapping[AttachmentDataProviderType.Mailbox] = getIconForFileProvider(
    ControlIcons.Recent,
    styles.recentAttachmentsIcon
);
fileProviderIconMapping[AttachmentDataProviderType.GDrive] = getIconForGDrive();
fileProviderIconMapping[AttachmentDataProviderType.MailMessage] = getIconForFileProvider(
    ControlIcons.Mail,
    styles.mailMessageIcon
);
fileProviderIconMapping[ClientOnlyFileProviderType.Groups] = getIconForFileProvider(
    ControlIcons.Group,
    styles.groupIcon
);
fileProviderIconMapping[AttachmentDataProviderType.WopiBox] =
    fileProviderIconMapping[AttachmentDataProviderType.Box];
fileProviderIconMapping[AttachmentDataProviderType.WopiEgnyte] = getIconForFileProvider(
    ControlIcons.EgnyteLogo,
    styles.egnyteIcon
);
fileProviderIconMapping[AttachmentDataProviderType.WopiDropbox] =
    fileProviderIconMapping[AttachmentDataProviderType.Dropbox];

// The provider big icons
const bigFileProviderIconMapping = {};
bigFileProviderIconMapping[AttachmentDataProviderType.OneDrivePro] = getIconForFileProvider(
    ControlIcons.OneDriveLogo,
    styles.oneDriveIconBig
);
bigFileProviderIconMapping[AttachmentDataProviderType.OneDriveConsumer] = getIconForFileProvider(
    ControlIcons.OneDriveLogo,
    styles.oneDriveIconBig
);
bigFileProviderIconMapping[AttachmentDataProviderType.Dropbox] = getIconForFileProvider(
    ControlIcons.DropboxLogo,
    styles.dropboxIconBig
);
bigFileProviderIconMapping[AttachmentDataProviderType.Box] = getIconForFileProvider(
    ControlIcons.BoxLogo,
    styles.boxIconBig
);
bigFileProviderIconMapping[AttachmentDataProviderType.Facebook] = getIconForFileProvider(
    ControlIcons.FacebookLogo,
    styles.facebookIconBig
);
bigFileProviderIconMapping[AttachmentDataProviderType.GDrive] = getIconForGDrive(true /* isBig */);
bigFileProviderIconMapping[AttachmentDataProviderType.WopiBox] =
    bigFileProviderIconMapping[AttachmentDataProviderType.Box];
bigFileProviderIconMapping[AttachmentDataProviderType.WopiEgnyte] = getIconForFileProvider(
    ControlIcons.EgnyteLogo,
    styles.egnyteIconBig
);
bigFileProviderIconMapping[AttachmentDataProviderType.WopiDropbox] =
    bigFileProviderIconMapping[AttachmentDataProviderType.Dropbox];

// The greyed out provider icons
const disabledFileProviderIconMapping = {};
disabledFileProviderIconMapping[AttachmentDataProviderType.OneDrivePro] = getIconForFileProvider(
    ControlIcons.OneDriveLogo,
    styles.disabledOneDriveIcon
);
disabledFileProviderIconMapping[
    AttachmentDataProviderType.OneDriveConsumer
] = getIconForFileProvider(ControlIcons.OneDriveLogo, styles.disabledOneDriveIcon);
disabledFileProviderIconMapping[AttachmentDataProviderType.Dropbox] = getIconForFileProvider(
    ControlIcons.DropboxLogo,
    styles.disabledDropboxIcon
);
disabledFileProviderIconMapping[AttachmentDataProviderType.Box] = getIconForFileProvider(
    ControlIcons.BoxLogo,
    styles.disabledBoxIcon
);
disabledFileProviderIconMapping[AttachmentDataProviderType.Facebook] = getIconForFileProvider(
    ControlIcons.FacebookLogo,
    styles.disabledFacebookIcon
);
disabledFileProviderIconMapping[AttachmentDataProviderType.Mailbox] = getIconForFileProvider(
    ControlIcons.Recent,
    styles.disabledRecentAttachmentsIcon
);
disabledFileProviderIconMapping[AttachmentDataProviderType.GDrive] = getIconForFileProvider(
    ControlIcons.GoogleDriveLogo,
    styles.disabledGoogleDriveIcon
);
disabledFileProviderIconMapping[AttachmentDataProviderType.MailMessage] = getIconForFileProvider(
    ControlIcons.Mail,
    styles.disabledMailMessageIcon
);
disabledFileProviderIconMapping[ClientOnlyFileProviderType.Groups] = getIconForFileProvider(
    ControlIcons.Group,
    styles.disabledGroupIcon
);
disabledFileProviderIconMapping[AttachmentDataProviderType.WopiBox] =
    disabledFileProviderIconMapping[AttachmentDataProviderType.Box];
disabledFileProviderIconMapping[AttachmentDataProviderType.WopiEgnyte] = getIconForFileProvider(
    ControlIcons.EgnyteLogo,
    styles.disabledEgnyteIcon
);
disabledFileProviderIconMapping[AttachmentDataProviderType.WopiDropbox] =
    disabledFileProviderIconMapping[AttachmentDataProviderType.Dropbox];

export default function getIconCSSForFileProvider(
    fileProviderType: FileProviderViewType | AttachmentDataProviderType,
    disabled: boolean = false,
    bigIcon: boolean = false
): JSX.Element {
    if (!disabled) {
        if (bigIcon) {
            if (fileProviderType in bigFileProviderIconMapping) {
                return bigFileProviderIconMapping[fileProviderType];
            }
        } else if (fileProviderType in fileProviderIconMapping) {
            return fileProviderIconMapping[fileProviderType];
        }
    } else if (fileProviderType in disabledFileProviderIconMapping) {
        return disabledFileProviderIconMapping[fileProviderType];
    }

    throw new Error(
        'Unrecoginized provider type. No mapping available for the provider type to icon'
    );
}
